import { motion } from "framer-motion";
import { Truck, Route, LifeBuoy, BatteryCharging, CircleDot, Fuel, Lightbulb, Bike } from "lucide-react";

const IMG_ROADSIDE =
  "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&q=85";
const IMG_NIGHT =
  "https://images.unsplash.com/photo-1771208743387-ed2187875da8?crop=entropy&cs=srgb&fm=jpg&q=85";

const cardAnim = (i) => ({
  initial: { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.55, delay: (i % 3) * 0.08 },
});

function Card({ i, icon: Icon, title, text, span, img }) {
  return (
    <motion.article
      {...cardAnim(i)}
      data-testid={`service-card-${i}`}
      className={`group relative rounded-2xl border border-white/10 bg-night-800/60 overflow-hidden hover:border-brand/60 transition-all duration-300 hover:-translate-y-1 ${span}`}
    >
      {img && (
        <div className="absolute inset-0" aria-hidden="true">
          <img src={img} alt="" className="w-full h-full object-cover duotone-img opacity-25 group-hover:opacity-40 group-hover:scale-105 transition-all duration-700" loading="lazy" />
          <div className="absolute inset-0 bg-gradient-to-t from-night-900 via-night-900/70 to-night-900/30" />
        </div>
      )}
      <div className="relative p-6 sm:p-7 flex flex-col h-full">
        <div className="w-12 h-12 rounded-xl bg-brand/15 border border-brand/30 flex items-center justify-center group-hover:bg-brand group-hover:text-night-900 text-brand transition-all duration-300">
          <Icon className="w-6 h-6" strokeWidth={2.2} />
        </div>
        <h3 className="font-display font-bold uppercase text-2xl mt-4 text-white">{title}</h3>
        <p className="text-sm text-slate-400 mt-2 leading-relaxed">{text}</p>
      </div>
    </motion.article>
  );
}

export default function Services() {
  return (
    <section id="hizmetler" data-testid="services-bento" className="py-16 lg:py-24 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.6 }}
          className="mb-10 lg:mb-14"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Hizmetlerimiz</p>
          <h2 className="font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3 leading-[0.95]">
            Yoldaki her duruma
            <br />
            <span className="text-outline">tek numara</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
          <Card
            i={0}
            icon={Truck}
            span="lg:col-span-7"
            img={IMG_NIGHT}
            title="İl İçi Oto Çekici"
            text="Konya merkez ve tüm ilçelerde aracınızı en kısa sürede yerinden alıyor, istediğiniz servise veya adrese hasarsız taşıyoruz."
          />
          <Card
            i={1}
            icon={Route}
            span="lg:col-span-5"
            title="Şehirler Arası (İl Dışı) Çekici"
            text="Konya'dan Türkiye'nin her iline profesyonel araç taşıma. Uzun yolda güvenli, planlı ve zamanında teslim."
          />
          <Card
            i={2}
            icon={LifeBuoy}
            span="lg:col-span-5"
            img={IMG_ROADSIDE}
            title="Kaza ve Kurtarma"
            text="Hendekten, çukurdan, bataklıktan... Kazalı aracınızı güvenle kurtarıyor, taşıma ve sigorta sürecini sizin için yönetiyoruz."
          />
          <Card
            i={3}
            icon={BatteryCharging}
            span="lg:col-span-4"
            title="Akü Takviye"
            text="Aracınız açmıyorsa hemen gelip akü takviyesi yapıyoruz. Merkezde ortalama 15-20 dakika."
          />
          <Card
            i={4}
            icon={CircleDot}
            span="lg:col-span-3"
            title="Lastik Değişimi"
            text="Stepne yok mu? Yerinde lastik değişimi ve şişirme hizmeti."
          />
          <Card
            i={5}
            icon={Fuel}
            span="lg:col-span-4"
            title="Yakıt İkmali"
            text="Yolda yakıtın mı bitti? Kısa sürede yeterli yakıtı ulaştırıp yola devam etmenizi sağlıyoruz."
          />
          <Card
            i={6}
            icon={Lightbulb}
            span="lg:col-span-4"
            title="Işık Hizmeti"
            text="Karanlıkta kalanlara acil ışık ve elektrik desteği. Gece görüş ve güvenlik için hızlı müdahale."
          />
          <Card
            i={7}
            icon={Bike}
            span="lg:col-span-4"
            title="Motosiklet ve Lüks Araç Taşıma"
            text="Motosikletiniz ve lüks aracınız için özel platform; kilitleme ve hasarsız taşıma garantisiyle."
          />
        </div>
      </div>
    </section>
  );
}
